import React from 'react';
import GlobalCart from '@fff-web/fff-cart';

import { getEnv } from '../../../environment';
import fffLogo from '../../assets/fff-logo.svg';
import './Header.css';
import classNames from 'classnames';

const NMFHeaderContent = ({
  showCart,
  env,
  newMemberState,
  onNewMemberStateFetched,
}) => (
  <div
    className={classNames('header__content', { 'with-cart': showCart })}
    data-testid="nmf_header"
  >
    <span className="fff-logo">
      <img src={fffLogo} alt="logo" />
    </span>
    {showCart && (
      <div className="cart-container">
        <GlobalCart
          env={env.name}
          newMemberState={newMemberState}
          onNewMemberStateFetched={onNewMemberStateFetched}
        />
      </div>
    )}
  </div>
);

export default NMFHeaderContent;
